import { Component, Inject, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JmepDiscoverService } from './../../../../service/jmep-discover.service';
import { Options } from 'tabulator-tables';
import { NgForm } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  DialogService,
  TabulatorService,
  FusionTransformationService,
  UserAuth,
  IPsService,
  NotificationService
} from '@nrwl/common-lib';
import { DISCOVERY_TYPES, DISCOVERY_MODE } from '../../../datasource.entity.widget/models/types';

@Component({
  selector: 'nrwl-jmep-discover-dialog',
  templateUrl: './jmep-discover-dialog.component.html',
  styleUrls: ['./jmep-discover-dialog.component.scss'],
  providers: [JmepDiscoverService]
})
export class JmepDiscoverDialogComponent implements OnInit, OnDestroy {
  @ViewChild('currentForm') discoveryForm: NgForm;
  hasReadWriteRole = false;
  discoveryMode = 'normal';
  isLoadingProgress = true;
  serverConfigDiscoveryMode = [];
  formData = {
    ipaddress: null,
    iprange: null,
    subnet: null,
    timeToWait: null
  };
  finalUpdatedFieldsOptions = [];
  discoveredFiles = {};
  selectedTabIndex = 0;
  defaultTimeToWait = '5';
  timeToWaitRange = '5-60'; // seconds
  discoveryResponseStatus = null;
  discoveryResponseMessage = null;
  discoveryResponseError = null;
  dataSource: any;
  discoveryStatus = [];
  showDiscoveyResTable = true;
  showBroadcastTab = false;
  showZTPDiscovery = false;
  dataOptions = {
    ipaddress: {
      data: [],
      error: false,
      errorText: [],
      sectionName: 'ip-individual'
    },
    iprange: {
      data: [],
      error: false,
      errorText: [],
      sectionName: 'ip-range'
    },
    subnet: {
      data: [],
      error: false,
      errorText: [],
      sectionName: 'ip-subnet'
    },
    timeToWait: {
      data: [],
      error: false,
      errorText: [],
      sectionName: 'discovery-duration-in-sec'
    }
  };
  widgetOptions = {
    defaultSort: {
      id: 'errorMsg',
      type: 'text',
      reverse: true
    },
    pagination: {
      itemsPerPage: 1000
    }
  };
  actions = {};
  searchText = {};
  sendAction = {};
  errorTextLimit = 2; //Limit to show errors
  savingInProgress = false;
  showDiscoveryResponse = false;
  requestJSONFormat = {
    format: 'json',
    id: 'discovery-config',
    value: {
      data: []
    }
  };
  dialogOptions = {
    preserveScope: true,
    autoWrap: true,
    skipHide: true
  };
  statusJobId = null;
  discoveryTaskStatus = null;
  discoveryStatusResponseMessage = null;
  selectedEsam: any;
  esamId: string = null;
  esamName: string = null;
  esamURL: string = null;
  isCheckBoxEnabled = false;
  discoveryTable: Options;
  private readonly unsubscribe: Subject<void> = new Subject();
  constructor(
    private jmepDiscoverService: JmepDiscoverService,
    private tabulatorService: TabulatorService,
    private fusionTransformationService: FusionTransformationService,
    private readonly dialogService: DialogService,
    public dialogRef: MatDialogRef<JmepDiscoverDialogComponent>,
    private readonly userAuth: UserAuth,
    private readonly ipsService: IPsService,
    private readonly notificationService: NotificationService,
    //eslint-disable-next-line
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.hasReadWriteRole = this.userAuth.isAuthedFor('READ_WRITE');
    this.discoveryTable = this.tabulatorService.commonTableConfiguration();
    this.discoveryTable.persistenceID = 'jmeps-discovery';
    this.discoveryTable.groupHeader = this.tabulatorService.groupHeader;
  }

  ngOnInit(): void {
    this.selectedEsam = this.data?.selectedEsam;
    this.esamId = this.data?.selectedEsam?.id;
    this.esamName = this.data?.selectedEsam?.name?.label;
    this.esamURL = this.data?.selectedEsam?.dataItem?.connections?.[0]?.uri || '';
    if (this.data?.selectedEsam) {
      this.jmepDiscoverService.setSelectedEsamInfo(this.data.selectedEsam);
    }
    this.showZTPDiscovery = sessionStorage.getItem('ZTPDiscovery') === 'true' ? true : false;
    this.jmepDiscoverService
      .getJMEPDiscovery({ url: this.esamId, discoverType: DISCOVERY_TYPES.discovery })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        if (response) {
          this.isLoadingProgress = false;
          this.jmepDiscoveredFiles(response);
        }
      });
    if (this.data?.serverConfig?.discovery?.mode === 'IP-1') {
      this.showBroadcastTab = true;
      this.selectedTabIndex = 1;
    }
  }

  //eslint-disable-next-line
  changeTab(event: any): void {
    if (event.tab.textLabel === 'Discovery') {
      //this.discoveryResults(this.resMockData);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  //eslint-disable-next-line
  jmepDiscoveredFiles(response: any): void {
    this.isLoadingProgress = false;
    if (response?.value?.data?.length) {
      const responseData = response.value.data;
      this.jmepDiscoverService.setDiscoveryData(responseData);
      this.formData.ipaddress = this.jmepDiscoverService.getIPBySection(
        responseData,
        this.dataOptions.ipaddress.sectionName
      );
      this.formData.iprange = this.jmepDiscoverService.getIPBySection(
        responseData,
        this.dataOptions.iprange.sectionName
      );
      this.formData.subnet = this.jmepDiscoverService.getIPBySection(
        responseData,
        this.dataOptions.subnet.sectionName
      );
      this.formData.timeToWait = this.jmepDiscoverService.getTimeToWaitAttributeValue(
        responseData,
        this.dataOptions.timeToWait.sectionName
      );
      this.onIpAddressChange();
      this.onIpRangeChange();
      this.onSubnetChange();
    } else {
      this.formData.timeToWait = this.defaultTimeToWait;
    }
    this.onTimeToWaitChange();
  }

  clearData(option: string): void {
    this.dataOptions[option].error = false;
    this.dataOptions[option].errorText = [];
    this.dataOptions[option].data = [];
  }

  onIpAddressChange(): void {
    this.clearData('ipaddress');
    const lines = this.jmepDiscoverService.getIpList(this.formData.ipaddress);
    for (let address = 0; address < lines.length; address++) {
      this.dataOptions.ipaddress.data.push(lines[address]);
      const isValid = this.ipsService.isValidIP(lines[address]);
      if (!isValid && this.dataOptions.ipaddress.errorText.length < this.errorTextLimit) {
        this.dataOptions.ipaddress.error = true;
        const errorText = lines[address] + ' is not valid IPV4 or IPV6 address';
        this.dataOptions.ipaddress.errorText.push(errorText);
      }
    }
  }

  onIpRangeChange(): void {
    this.clearData('iprange');
    const lines = this.jmepDiscoverService.getIpList(this.formData.iprange);
    for (let address = 0; address < lines.length; address++) {
      this.dataOptions.iprange.data.push(lines[address]);
      const validIp = this.jmepDiscoverService.isValidIpRange(lines[address]);
      if (!validIp.valid && this.dataOptions.iprange.errorText.length < this.errorTextLimit) {
        this.dataOptions.iprange.error = true;
        const errorText = validIp.error.invalidAddress
          ? lines[address] + ' is not valid address'
          : lines[address] + ' is not valid range';
        this.dataOptions.iprange.errorText.push(errorText);
      }
    }
  }

  onSubnetChange(): void {
    this.clearData('subnet');
    const lines = this.jmepDiscoverService.getIpList(this.formData.subnet);
    for (let address = 0; address < lines.length; address++) {
      this.dataOptions.subnet.data.push(lines[address]);
      const isValid = this.jmepDiscoverService.isValidIPv4ClassCCIDR(lines[address]);
      if (!isValid && this.dataOptions.subnet.errorText.length < this.errorTextLimit) {
        this.dataOptions.subnet.error = true;
        const errorText = lines[address] + ' is not valid Subnet Range (CIDR)';
        this.dataOptions.subnet.errorText.push(errorText);
      }
    }
    this.updateTransmitDuration();
  }

  updateTransmitDuration(): void {
    let numOfIPs = 0;
    let transmitDuration = parseInt(this.defaultTimeToWait);
    const subnetList = this.dataOptions.subnet.data;
    const ipAddresses = this.dataOptions.ipaddress.data;
    const ipAddressRange = this.dataOptions.iprange.data;
    if (this.dataOptions.ipaddress.errorText.length === 0 && ipAddresses.length > 0) {
      numOfIPs = ipAddresses.length;
    }
    if (this.dataOptions.iprange.errorText.length === 0 && ipAddressRange.length > 0) {
      for (let k = 0; k < ipAddressRange.length; k++) {
        const splitRange = ipAddressRange[k].split('-');
        const rangesIPCount = this.jmepDiscoverService.getNumberOfIPsInRange(
          splitRange[0],
          splitRange[1]
        );
        if (rangesIPCount > 0) {
          numOfIPs = numOfIPs + rangesIPCount;
        }
      }
    }
    if (subnetList.length > 0) {
      for (let i = 0; i < subnetList.length; i++) {
        const splitSubnet = subnetList[i].split('/');
        const ipsCountsArr = this.jmepDiscoverService.subnetIPscountObj.filter(function (o) {
          return o.subnet === splitSubnet[1];
        });
        if (ipsCountsArr.length > 0) {
          numOfIPs = numOfIPs + ipsCountsArr[0].normalCount;
        }
      }
    }
    if (numOfIPs) {
      transmitDuration = this.jmepDiscoverService.getTransmitDuration(numOfIPs);
    }
    this.formData.timeToWait = transmitDuration;
    this.clearData('timeToWait');
    this.dataOptions.timeToWait.data.push(transmitDuration);
  }

  onTimeToWaitChange(): void {
    this.clearData('timeToWait');
    const time = this.formData.timeToWait;
    this.dataOptions.timeToWait.data.push(time);
    const errMsg = this.jmepDiscoverService.validateTimeRange(
      this.formData.timeToWait,
      this.timeToWaitRange,
      false
    );
    if (errMsg) {
      this.dataOptions.timeToWait.error = true;
      this.dataOptions.timeToWait.errorText.push(errMsg);
    }
  }

  isValidAddress(): boolean {
    return !(
      this.dataOptions.ipaddress.error ||
      this.dataOptions.iprange.error ||
      this.dataOptions.subnet.error ||
      this.dataOptions.timeToWait.error ||
      ((this.formData.ipaddress === undefined ||
        this.formData.ipaddress === '' ||
        this.formData?.ipaddress?.length === 0) &&
        (this.formData.iprange === undefined ||
          this.formData.iprange === '' ||
          this.formData?.iprange?.length === 0) &&
        (this.formData.subnet === undefined ||
          this.formData.subnet === '' ||
          this.formData?.subnet?.length === 0))
    );
  }

  clearExistingDiscoveryResponse(): void {
    this.discoveryResponseStatus = null;
    this.discoveryResponseMessage = null;
    this.discoveryResponseError = null;
    this.showDiscoveyResTable = false;
    this.finalUpdatedFieldsOptions = [];
    this.dataSource = [];
    this.discoveryStatus = [];
  }

  saveDiscoverDetails(): void {
    this.clearExistingDiscoveryResponse();
    this.createJMEPDiscoveryData(
      this.dataOptions.ipaddress.sectionName,
      this.dataOptions.ipaddress.data,
      true
    );
    this.createJMEPDiscoveryData(
      this.dataOptions.iprange.sectionName,
      this.dataOptions.iprange.data,
      true
    );
    this.createJMEPDiscoveryData(
      this.dataOptions.subnet.sectionName,
      this.dataOptions.subnet.data,
      true
    );
    this.createJMEPDiscoveryData(
      this.dataOptions.timeToWait.sectionName,
      this.dataOptions.timeToWait.data[0],
      false
    );
    this.createJMEPDiscoveryData('esam-name', this.esamName, false);
    this.createJMEPDiscoveryData('discovery-mode', DISCOVERY_MODE.normal, false);
    this.createJMEPDiscoveryData('auto-assign-probe-ip', 'true', false);
    this.requestJSONFormat.value.data = this.finalUpdatedFieldsOptions;
    this.onSetJMEPDiscovery('startDiscovery');
  }

  hasDataOptions(): number {
    return (
      this.dataOptions.ipaddress.data.length ||
      this.dataOptions.iprange.data.length ||
      this.dataOptions.subnet.data.length
    );
  }

  onClearAllAddresses(): void {
    const params = {
      id: 'discovery.clear_all_addresses',
      callBackService: this,
      callBackFuntion: this.clearAllAddresses,
      callBackFnParams: {
        self: this
      }
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }

  showDiscoverSetup(): void {
    this.showDiscoveryResponse = false;
  }

  //eslint-disable-next-line
  clearAllAddresses(thisRef: any): void {
    thisRef.formData.ipaddress = [];
    thisRef.formData.iprange = [];
    thisRef.formData.subnet = [];
    thisRef.clearData('ipaddress');
    thisRef.clearData('iprange');
    thisRef.clearData('subnet');
    thisRef.createJMEPDiscoveryData(
      thisRef.dataOptions.ipaddress.sectionName,
      thisRef.dataOptions.ipaddress.data,
      true
    );
    thisRef.createJMEPDiscoveryData(
      thisRef.dataOptions.iprange.sectionName,
      thisRef.dataOptions.iprange.data,
      true
    );
    thisRef.createJMEPDiscoveryData(
      thisRef.dataOptions.subnet.sectionName,
      thisRef.dataOptions.subnet.data,
      true
    );
    thisRef.createJMEPDiscoveryData(
      thisRef.dataOptions.timeToWait.sectionName,
      thisRef.dataOptions.timeToWait.data[0],
      false
    );
    thisRef.createJMEPDiscoveryData('esam-name', thisRef.esamName, false);
    thisRef.createJMEPDiscoveryData('discovery-mode', DISCOVERY_MODE.normal, false);
    thisRef.createJMEPDiscoveryData('auto-assign-probe-ip', 'true', false);
    thisRef.requestJSONFormat.value.data = thisRef.finalUpdatedFieldsOptions;
    if (!thisRef.hasDataOptions()) {
      thisRef.onSetJMEPDiscovery('clearAllAddresses');
    }
  }

  onSetJMEPDiscovery(eventType: string): void {
    this.savingInProgress = eventType === 'startDiscovery';
    this.statusJobId = null;
    this.discoveryStatusResponseMessage = null;
    this.jmepDiscoverService
      .setJMEPDiscovery({
        url: this.esamURL,
        esamId: this.esamId,
        option: this.requestJSONFormat,
        discoverType: DISCOVERY_TYPES.discovery,
        eventType: eventType
      })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.setDiscoverComplete(response);
        },
        errorRes => {
          this.discoveryResponseError = this.parseErrorMessage(errorRes?.error?.data?.message);
          this.notificationService.onFail(
            'Failed to JMEP discovery ' + this.discoveryResponseError
          );
          this.savingInProgress = false;
        }
      );
  }

  parseErrorMessage(errorString: string): string {
    let errorMessage = '';
    const regex = /Error:\s*\d+\s*:\s*"({.*})"/;
    const match = errorString.match(regex);
    if (match && match[1]) {
      const errorDetails = JSON.parse(match[1]);
      const generalError = errorDetails?.['general-error'];
      errorMessage = generalError?.['error-message'] || '';
    }
    return errorMessage;
  }

  //eslint-disable-next-line
  discoveryStatusMessage(response: any): void {
    if (response?.data?.['general-info']?.status?.jobStatus) {
      this.discoveryTaskStatus = response.data['general-info'].status.jobStatus;
      if (this.discoveryTaskStatus === 'FINISHED') {
        this.showDiscoveryResponse = true;
        if (response.data['general-info'].status.message.indexOf('No JMEPs found') != -1) {
          this.savingInProgress = false;
          this.discoveryResponseMessage = response.data['general-info'].status.message;
        } else {
          this.jmepDiscoverService
            .getDiscoveryResult(this.statusJobId)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(res => {
              this.discoveryResults(res);
            });
        }
      } else {
        this.discoveryStatusResponseMessage = response?.data?.['general-info']?.status?.message;
      }
    }
  }

  //eslint-disable-next-line
  discoveryResults(response: any): void {
    if (response?.data?.['general-info']?.['discovery-results']) {
      this.discoveryResponseMessage = response.data['general-info']['discovery-results'].message;
      if (response.data['general-info']['discovery-results']['results']) {
        this.showDiscoveyResTable = true;
        this.assignDiscoveryResultTable(
          response.data['general-info']['discovery-results']['results']
        );
      }
    }
  }

  //eslint-disable-next-line
  assignDiscoveryResultTable(res: any): void {
    this.jmepDiscoverService.clearResultCounts();
    const tableObj = res.map(item =>
      this.jmepDiscoverService.getTableObject(item, DISCOVERY_TYPES.discovery)
    );
    this.dataSource = this.fusionTransformationService.transformData('jmeps-discovery', tableObj);
    if (tableObj?.length) {
      const activeColumns = Object.keys(tableObj?.[0]);
      this.dataSource.column = this.dataSource.column.map(el => {
        if (activeColumns.find(field => el.tabulatorInfo.field === field && field !== 'id')) {
          el.tabulatorInfo.visible = true;
        } else {
          el.tabulatorInfo.visible = false;
        }
        return el;
      });
    }
    this.discoveryStatus = this.jmepDiscoverService.getDiscoveryStatesCount(
      res.length,
      DISCOVERY_TYPES.discovery
    );
    this.discoveryTable.columns = this.dataSource.column;
    this.discoveryTable.data = this.dataSource.data;
    this.discoveryTable.minHeight = 250;
    this.discoveryTable.height = 400;
    if (this.discoveryTable.persistence) {
      this.discoveryTable.persistence.sort = true;
      this.discoveryTable.persistence.page = true;
      this.discoveryTable.initialSort = [{ column: 'ipAddress', dir: 'asc' }];
    }
    this.savingInProgress = false;
    this.discoveryTable = Object.assign({}, this.discoveryTable);
  }

  //eslint-disable-next-line
  setDiscoverComplete(response: any): void {
    let jobId = null;
    this.discoveryTaskStatus = 'IN_PROGRESS';
    const discoveryTask = response.status;
    this.discoveryResponseStatus = response.status;
    if (response.status === 'success') {
      this.statusJobId = response.data['general-info'].status.jobId;
      jobId = response.data['general-info'].status.jobId;
      setInterval(() => {
        if (this.discoveryTaskStatus !== 'FINISHED' && discoveryTask === 'success') {
          this.jmepDiscoverService
            .discoveryStatusMessage(jobId)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(res => {
              if (res) {
                this.discoveryStatusMessage(res);
              }
            });
        }
      }, 5000);
    }
  }

  //eslint-disable-next-line
  createJMEPDiscoveryData(section, fieldValues, isSubAttributes): void {
    const sectionIndex = this.finalUpdatedFieldsOptions.findIndex(field => field.name === section);
    if (isSubAttributes) {
      const subAttributesArray = [];
      fieldValues.forEach(value => {
        subAttributesArray.push({
          id: 'ip',
          value: value
        });
      });
      if (sectionIndex >= 0) {
        this.finalUpdatedFieldsOptions[sectionIndex].subAttributes =
          this.finalUpdatedFieldsOptions[sectionIndex].subAttributes.concat(subAttributesArray);
      } else {
        this.finalUpdatedFieldsOptions.push({ name: section, subAttributes: subAttributesArray });
      }
    } else {
      if (sectionIndex >= 0) {
        this.finalUpdatedFieldsOptions[sectionIndex].value = fieldValues;
      } else {
        this.finalUpdatedFieldsOptions.push({ name: section, value: fieldValues });
      }
    }
  }
}
